// Shared Industry reference list — single source of truth reused across the
// SmartEvaluate / SmartImprove intake and the SmartInspect ROI Step 1 dropdown.
export const INDUSTRIES = [
  "Consumer Goods",
  "Food & Beverage",
  "Pharma / Life Sciences",
  "Industrial / Manufacturing",
  "Retail / E-commerce",
  "Automotive",
  "Chemicals",
  "3PL / Logistics",
  "Other",
];
